import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.currentIndex = 0;

        if (this.el.querySelectorAll('.c-video_activate')) {
            this.el.querySelectorAll('.c-video_activate').forEach((elt) => {
                elt.addEventListener('click', (e) => {
                    let index = parseInt(elt.closest('.c-video').getAttribute("data-index"));
                    this.activateVideo(index);
                });
            });
        }

        if (this.el.querySelectorAll('.c-video_play')) {
            this.el.querySelectorAll('.c-video_play').forEach((elt) => {
                elt.addEventListener('click', (e) => {
                    let index = parseInt(elt.closest('.c-video').getAttribute("data-index"));
                    this.playVideo(index);
                });
            });
        }
    }

    activateVideo(index) {
        this.currentIndex = index;

        let active = this.el.querySelector('.c-video.-active');
        if (active)  {
            active.classList.remove('-active');
            active.classList.remove('-playing');

            if (active.querySelector('[data-module-player]')) {
                this.call('pause', false, 'Player', active.querySelector('[data-module-player]').getAttribute('data-module-player'));
            }
        }

        this.el.querySelector('.c-video[data-index="' + index + '"]').classList.add('-active');
    }

    playVideo(index) {
        let current = this.el.querySelector('.c-video[data-index="' + index + '"]')
        current.classList.add('-playing');

        if (current.querySelector('[data-module-player]')) {
            this.call('play', false, 'Player', current.querySelector('[data-module-player]').getAttribute('data-module-player'));
        }
    }
}
